export default {
  zh: {
    permissionProfile: '权限设置',
    inputTeam: '点击选择部门',
    view: '查看',
    tab: 'Tab',
    permissionSetting: '权限设置',
    description: '描述',
    create: '创建',
  },
  en: {
    permissionProfile: 'Permission Profile',
    inputTeam: 'select Team',
    view: 'View',
    tab: 'Tab',
    permissionSetting: 'Permission Setting',
    description: 'Description',
    create: 'Create',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/PermissionProfile/i18n.js